import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PrintableDocument } from '@sc/portal.fe.lib.app-components';

@Injectable({
  providedIn: 'root'
})
export class PolicyDocumentsService {
  constructor(private http: HttpClient) {}
  getDocuments(policyNumber: string): Observable<PrintableDocument[]> {
    const params = new HttpParams({ fromObject: { policyNumber } });
    return this.http
      .get(`${environment.server.api.portalpas}/documents/DocumentsByPolicyNumber`, { params })
      .pipe(
        map((response: {documents: Array<PrintableDocument>}) =>
          response.documents.map(
            each =>
              new PrintableDocument({ ...each, name: policyNumber })
          )
        )
      );
  }
}
